import install from './install'

/**
 * Hubspot form error types
 * @see https://legacydocs.hubspot.com/docs/methods/forms/submit_form
 * @readonly
 * @enum {string}
 */
export const HubspotFormErrorTypes = {
  INVALID_EMAIL: 'INVALID_EMAIL',
  BLOCKED_EMAIL: 'BLOCKED_EMAIL',
}

export default {
  install,
}
